export default __webpack_public_path__ + "static/media/35167d3419d6fa20a30f60fedb5f297f1581605551742.6bc33cf6.webp";